import tippy from 'tippy.js';

export default () => {
  document.querySelectorAll('.badge').forEach(async (block) => {
    const text = block.getAttribute('title');

    if (!text) return;

    tippy(block, {
      content: text,
      duration: 0,
      delay: [200, 0],
      allowHTML: true,
      maxWidth: 250,
      placement: 'top-start',
    });
  });
};


